<template>
  <div class="article" style="padding: 0.49rem 0 0.5rem 0">
    <div class="title">
      <van-tabs
        v-model="activeName"
        color="#93683D"
        :swipeable="true"
        :sticky="true"
        offset-top="0.49rem"
      >
        <van-tab
          v-for="newstype in newstypeList"
          :key="newstype.id"
          :title="newstype.title"
          :name="newstype.id"
        >
          <Content :typeId="newstype.id" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Content from './Content'
import { getnewstype } from '../../api/home'
export default {
  components: {
    Content
  },
  data () {
    return {
      activeName: 'a',
      newstypeList: [],
      loading: null
    }
  },
  created () {
    getnewstype()
      .then((res) => {
        this.newstypeList = res.data.backdata.newstype
        this.newstypeList.unshift({
          id: '0',
          title: '全部',
          sort: '1000',
          ctime: '0'
        })
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    // isLoading(val) {
    //   if (val) {
    //     this.loading = this.$toast.loading({
    //       message: "加载中...",
    //       forbidClick: true,
    //       duration: 0,
    //     });
    //   } else {
    //     this.loading.clear();
    //   }
    // },
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background:#ffffff')
  },
  beforeDestroy () {
    document.querySelector('body').setAttribute('style', 'background:#f3f1f4')
  }
}
</script>

<style lang="scss">
.article {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  .van-sticky {
    background: #ffffff;
  }
  .van-tabs__wrap {
    height: 0.49rem;
    margin: 0 0.2rem 0 0.2rem;
    border-bottom: 0.02rem solid #f3f1f4;

    .van-tabs__nav--line {
      font-size: 0.14rem;

      .van-tab {
        color: #333333;
        font-size: 0.14rem;
        line-height: 0.2rem;
      }

      .van-tab--active {
        font-size: 0.16rem;
        font-weight: bold;
        color: #93683d;
      }

      .van-tabs__line {
        height: 0.02rem;
        background: #93683d;
      }
    }
  }
}
</style>
